import React, { useState } from 'react';
import { Menu } from 'antd';
import {
  arrayOf, bool, shape, string,
} from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';

const SideMenu = ({
  selectedKey = null,
  sideMenuItems = [],
  collapsed = true,
}) => {
  const [openKeys, setOpenKeys] = useState([]);

  const handleOpenChange = (keys) => {
    if (collapsed) {
      setOpenKeys([]);

      return;
    }

    const latestOpenKey = keys.find((key) => !openKeys.includes(key));

    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  return (
    // @ts-ignore
    <Scrollbars
      className="navigation-side-menu-scrollbars"
      autoHide
      renderThumbVertical={(props) => (
        <div className="navigation-side-menu-container__scroll" {...props} />
      )}
    >
      <Menu
        className="navigation-side-menu"
        getPopupContainer={() => document.querySelector('.navigation-side-menu-container')}
        items={sideMenuItems}
        selectedKeys={[selectedKey]}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        theme="dark"
        mode="inline"
      />
    </Scrollbars>
  );
};

SideMenu.propTypes = {
  sideMenuItems: arrayOf(shape({})),
  selectedKey: string,
  collapsed: bool,
};

export default SideMenu;
